export enum Flags {
  PORTAL_MY_ACCESS = 'portal-my-access',
  HIDE_BUNDLE_CONTENT = 'hide-bundle-content',
  JIT_CONNECT = 'jit-connect',
 ADMIN_CUSTOM_ACCESS_DETAILS = 'admin-custom-access-details',
  ALLOW_SAOLA_SESSION_RECORDING = 'allow-saola-session-recording',
}
